import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import { compose, withStateHandlers } from 'recompose';

import { withSearchHandler } from 'decorators';
import { Button } from 'components/core/Button';
import { Container } from 'components/core/Page';
import { H1, H2 } from 'components/core/Typography';
import MapPin from 'components/svg/MapPin';

import { SearchBox } from 'components/search/SearchBox';

import './SearchHero.scss';

export const enhance = compose(
	withRouter,
	withStateHandlers(
		{ searchType: null },
		{
			setStorageSearchType: () => () => ({ searchType: null }),
			setVehicleSearchType: () => () => ({ searchType: 'vehicle' }),
		},
	),
	withSearchHandler,
);

export function SearchHero({
	className,
	headlineContent,
	handleSearch,
	headline,
	searchType,
	setStorageSearchType,
	setVehicleSearchType,
	subheading,
	searchBoxContent,
	withSearchType,
}) {
	return (
		<div className={classnames('search-hero', className)}>
			<Container className="content-container">
				{headlineContent}
				<H1
					color="white"
					className="hero-heading"
					size="large"
				>
					{headline}
				</H1>
				<H2
					color="white"
					className="hero-subheading"
				>
					{subheading}
				</H2>
			</Container>
			<div className="search-wrapper">
				<Container>
					{withSearchType && (
						<div className="search-type-toggle">
							<Button
								onClick={setStorageSearchType}
								className={classnames('toggle-button', {
									active: !searchType,
								})}
							>
								Storage Units
							</Button>
							{' | '}
							<Button
								onClick={setVehicleSearchType}
								className={classnames('toggle-button', {
									active: searchType === 'vehicle',
								})}
							>
								Vehicle Storage
							</Button>
						</div>
					)}
					<SearchBox
						onSearch={handleSearch}
						icon={<MapPin fill="gray" />}
						id="hero-search"
						useBrowserLocation
					/>
					{searchBoxContent}
				</Container>
			</div>
		</div>
	);
}

SearchHero.propTypes = {
	backgroundImages: PropTypes.shape({
		mobile: PropTypes.string,
		tablet: PropTypes.string,
		desktop: PropTypes.string,
	}),
	className: PropTypes.string,
	handleSearch: PropTypes.func.isRequired,
	headline: PropTypes.string,
	headlineContent: PropTypes.node,
	subheading: PropTypes.string,
	searchBoxContent: PropTypes.node,
	searchType: PropTypes.string,
	setStorageSearchType: PropTypes.func.isRequired,
	setVehicleSearchType: PropTypes.func.isRequired,
	withSearchType: PropTypes.bool,
};

SearchHero.defaultProps = {
	headline: 'Find the perfect storage unit at the best price',
	subheading: 'Search more locations and units than any other storage site',
	withSearchType: true,
};

export default enhance(SearchHero);
